<template>
  <div>
    <v-data-table
      :items="filteredItems"
      :headers="headers"
      :search="serverPagination ? '' : search"
      :loading="loading"
      :showSelect="showSelect"
      :page="page"
      @click:row="$emit('click:row', $event)"
      @pagination="pagination"
      :disable-pagination="disablePagination"
      :hide-default-footer="hideDefaultFooter"
      :server-items-length="serverPagination ? totalItems : -1"
      :disable-sort="disableSort"
      :footer-props="{ itemsPerPageOptions: [15, 25, 50, 100, -1] }"
    >
      <template v-slot:top>
        <table style="width: 100%">
          <tbody>
            <tr>
              <td colspan="100%">
                <v-row>
                  <v-col class="d-flex">
                    <v-text-field
                      class="ma-auto"
                      label="Szukaj"
                      @input="searchUp"
                      :value="search"
                      prepend-icon="fa-search"
                    ></v-text-field>
                  </v-col>
                  <v-col md="2" cols="6" class="d-flex">
                    <v-btn
                      rounded
                      color="error"
                      @click="clearFilters"
                      class="ma-auto"
                      >Wyczyść filtry</v-btn
                    >
                  </v-col>
                </v-row>
              </td>
            </tr>
            <tr v-if="!disableFilters">
              <td
                class="pr-2 pl-2"
                v-for="(header, index1) in headersWithFilter"
                :key="index1"
              >
                <v-select
                  :label="header.text"
                  v-model="header.myFilter"
                  multiple
                  :items="availableValues(header.value)"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ header.myFilter.length - 1 }} inne)</span
                    >
                  </template>
                </v-select>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template
        v-for="field in Object.keys($scopedSlots)"
        v-slot:[field]="{ item }"
      >
        <slot :name="field" :item="item" />
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: Array,
    headers: Array,
    loading: Boolean,
    showSelect: Boolean,
    disablePagination: Boolean,
    hideDefaultFooter: Boolean,
    serverPagination: Boolean,
    endpoint: String,
    disableFilters: Boolean,
    disableSort: Boolean
  },
  data() {
    return {
      search: "",
      itemsPerPage: 0,
      page: 1,
      searchDebounce: null,
      paginationItems: [],
      totalItems: 0,
    };
  },
  computed: {
    tableItems() {
      return this.serverPagination ? this.paginationItems : this.items;
    },
    headersWithFilter() {
      if (!this.headers) {
        return [];
      }
      return this.headers.filter(
        (el) => !el.disableCustomFiltering && el.value != "actions"
      );
    },
    filteredItems() {
      if (this.serverPagination) {
        return this.tableItems;
      }

      var vm = this;
      if (!vm.items) {
        return [];
      }
      if (vm.loading) {
        return [];
      }
      return vm.items.filter((el) => {
        var result = true;
        vm.headers.forEach((header) => {
          if (header.myFilter && header.myFilter.length > 0) {
            if (!header.myFilter.includes(el[header.value])) {
              result = false;
            }
          }
        });
        return result;
      });
    },
  },
  methods: {
    searchUp(input) {
      this.search = input;
      this.page = 1
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.getData();
      }, 250);
    },
    async getData() {
      if (!this.serverPagination) {
        return;
      }
      var url;
      if (this.endpoint.includes("?")) {
        url = this.endpoint + "&";
      } else {
        url = this.endpoint + "?";
      }
      var response = await this.$http.get(
        url +
          `page=${this.page}&itemsPerPage=${this.itemsPerPage}&search=${this.search}`
      );
      this.paginationItems = response.data.items;
      this.totalItems = response.data.totalItems;
      this.$emit("itemsLoaded", this.paginationItems);
    },
    pagination(options) {
      this.page = options.page;
      this.itemsPerPage = options.itemsPerPage;
      this.getData();
    },
    clearFilters() {
      this.headers.forEach((el) => (el.myFilter = []));
      this.search = "";
    },
    availableValues(propName) {
      var vm = this;
      var unique = vm.tableItems
        .map((el) => el[propName])
        .filter((v, i, a) => a.indexOf(v) === i);
      return unique;
    },
  },
  destroyed() {
    clearTimeout(this.searchDebounce);
  },
};
</script>

<style scoped>
.theme--light.v-data-table
  >>> .v-data-table__wrapper
  tbody
  tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}
.theme--dark.v-data-table >>> .v-data-table__wrapper tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>